export default __webpack_public_path__ + "static/media/google-cloud.0c8d95fe.svg";